import { X } from 'lucide-react';
import { useLocale, useT } from '@/lib/i18n';
import { METHODOLOGY, METHODOLOGY_ORDER } from '@/lib/methodology';

/** The single "how to read this" surface — replaces the global banner + every
 * per-tab repeat. Opened from the one HelpCircle in the FilterBar. */
export function MethodologySheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { locale } = useLocale();
  const t = useT();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex justify-end" role="dialog" aria-modal="true">
      <button
        type="button"
        aria-label="Lukk"
        onClick={onClose}
        className="absolute inset-0"
        style={{ backgroundColor: 'var(--overlay)' }}
      />
      <div className="relative flex h-full w-full max-w-md flex-col border-l border-border bg-surface shadow-pop">
        <header className="flex h-13 shrink-0 items-center justify-between border-b border-border px-5">
          <h2 className="text-section text-fg">{t.methodology()}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Lukk"
            className="grid min-h-[40px] min-w-[40px] place-items-center rounded-md p-2.5 text-fg-subtle transition-fast hover:bg-surface-2 hover:text-fg sm:min-h-0 sm:min-w-0 sm:p-1.5"
          >
            <X className="size-4" aria-hidden />
          </button>
        </header>
        <div className="flex flex-1 flex-col gap-5 overflow-y-auto p-4 sm:p-5">
          {METHODOLOGY_ORDER.map((id) => {
            const e = METHODOLOGY[id];
            return (
              <section key={id}>
                <h3 className="text-label font-semibold text-fg">{e.title[locale]}</h3>
                <p className="mt-1 text-label leading-relaxed text-fg-muted">{e.body[locale]}</p>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}
